import { useState } from "react";
import { gql } from "graphql-request";
import { gqlClient } from "../configs/api-config";
import { ServicesType } from "../types/server";
import { requestHelper } from "../helpers/request-helper";

export function useServices() {
  let [servicesData, setServicesData] = useState<ServicesType>();
  let [loading, setLoading] = useState(false);
  let [error, setError] = useState(null);

  function retrive(id: string) {
    setLoading(true);
    setError(null);
    return requestHelper(
      `
          query listServices($catID: String) {
            listServices(category: $catID) {
              id
              alias
              name
              display_name
              description
              unit
              pricing {
                id
                price
                variation {
                  id
                  alias
                  name
                }
              }
              children {
                id
                name
                alias
                display_name
                description
                unit
                pricing {
                  price
                  id
                  variation {
                    id
                    alias
                    name
                  }
                }
              }
            }
          }
        `,
      { catID: id }
    )
      .then((data) => {
        setServicesData({ data });
      })
      .catch((error) => {
        setError(error);
      })
      .finally(() => {
        setLoading(false);
      });
  }

  return { retrive, servicesData, loading, error };
}
